// extracted by mini-css-extract-plugin
module.exports = {"userGuide":"user-guide-module--userGuide--101Ig","logoHolder":"user-guide-module--logoHolder--1GWWr","guideDropdown":"user-guide-module--guideDropdown--2obHn"};